import React, {Component} from 'react';
import qiyeweixin from '../../images/img_qiyeweixin@2x.png'
import convert from '../../images/ic_zhuanhuan@2x.png'
import { BsyUtils } from '../../utils/Utils';
import LoginAccountInput from "../LoginAccountInput";
import BsyBtn from "../BsyBtn";
import tipAlert from "../BsyAlertTip/Staticize";
import './index.css'

class LoginQYZJWechatCode extends Component {
    state={
        mode: (window.data_config.qywecat_login && window.data_config.qywecat_zj_login) ? "1" : window.data_config.qywecat_zj_login  ?  "2" : window.data_config.qywecat_login ? "1" : "0",
        phoneError: false,
        phone: ''
    }
    gotoFeishuLogin1 = () =>{
        BsyUtils.redirectTo(window.data_config.qywecat_url, '_blank')
    }
    changeMode = (mode) =>{
        return () => {
            this.setState({mode: mode})
        }
    }
    gotoFeishuLogin = () => {
        const {phone} = this.state;
        if(phone){
            React.axios('/qyweixin/login',{mobile:phone}).then((res)=>{
                if(res.data.data.length > 1){
                    this.setState({
                        dingdingTeamList:res.data.data
                    })
                }else if(res.data.data.length === 1){
                    window.open(res.data.data[0].login_url)
                }else if(res.data.data.length === 0){
                    tipAlert({
                        type: 'warning',
                        msg: React.language('error.1010')
                    })
                }
            })
        }
        
    }

    changePhone = (event) => {
        const { value } = event.target;

        this.setState({
            phone: value,
            phoneError: false
        })
    }

    phoneValue = (rel) => {
        this.getPhone = rel
    }
    render() {
        const {mode, phoneError, phone} = this.state
        return (
            <div className="qiye_wechat-login">
                <div className={`title${mode === "2" ? " hasBack" : ""}`}>
                    {mode === "2" && <i className="icon-bsy-left" onClick={this.changeMode("1")} ></i>}
                    <span>{React.language('login.qywechat.self')}</span>
                </div>
                {mode !== "2" && <div className="qiye_wechat-code">
                    <div className="imgCont">
                        <img className='qiyeLogo' src={`${window.media_domain}/logo.png`} alt=""/>
                        <div className="convert">
                            <img src={convert} alt=""/>
                        </div>
                        <img src={qiyeweixin} alt=""/>
                    </div>
                    <div className="qiyezj_btn">
                        {window.data_config.qywecat_login && <button style={{marginRight: (window.data_config.qywecat_login && window.data_config.qywecat_zj_login) ? "0.625rem" : ""}} onClick={this.gotoFeishuLogin1} className="qrcode qiyezjBtn">
                            <a rel="noreferrer">{React.language('signin.qrcode')}</a>
                        </button>}
                        {window.data_config.qywecat_zj_login && <button onClick={this.changeMode("2")} className="mobile qiyezjBtn">
                            <a rel="noreferrer">{React.language('mobile.num.login')}</a>
                        </button>}
                    </div>
                </div>}
                {mode !== "2" && <div className="qiyeTip">
                    <div className="topTip">
                        {React.language('account.signin.wechatOpenTip')}
                    </div>
                    <div className="buttonTip">
                        <a rel="noreferrer" target="_blank" href={window.rootDirectroy +"/qyweixin/qywxregshow"}>{React.language('account.signin.corpOpen')}</a>
                    </div>
                </div>}
                {mode === "2" && <div className="mobileLoginCont">
                    <div className="feishuLogo">
                        <LoginAccountInput getValue={this.phoneValue} change={this.changePhone} error={phoneError} maxLength="12" value={phone} mode="mobile" placeholder={React.language('qiyewechat.phone.entry.tip')} />
                    </div>
                    <BsyBtn style={{ 'marginBottom': '1.875rem' }} onClick={this.gotoFeishuLogin} text={React.language('ok')} />
                </div>}

            </div>
        );
    }
}

export default LoginQYZJWechatCode;